import React from 'react';

export default function Topbar({ title, subtitle, actions }) {
  return (
    <div style={{
      position:'sticky', top:0, zIndex:100,
      background:'rgba(255,255,255,0.95)', backdropFilter:'blur(8px)',
      borderBottom:'1px solid var(--border)',
      padding:'14px 24px',
      display:'flex', justifyContent:'space-between', alignItems:'center',
    }}>
      <div>
        <h1 style={{ fontSize:18, fontWeight:700, color:'var(--navy)', margin:0, lineHeight:1.2 }}>{title}</h1>
        {subtitle && <p style={{ fontSize:12, color:'var(--text-tertiary)', margin:'2px 0 0' }}>{subtitle}</p>}
      </div>
      {actions && <div style={{ display:'flex', gap:8, alignItems:'center' }}>{actions}</div>}
    </div>
  );
}
